import { fnIsSwitchToCartItems } from '../../modules/cartCheckout/flags';
import ApiInterface from '../apiInterface';
import updateQty from './updateQty';
import addItemBackToCart from './addItemBackToCart';
import postApplePayAddToCart from './postApplePayAddToCart';
import postPayPalAddToCart from './postPayPalAddToCart';
import { postInitiateSddStampNode, postUpdateSddStampNode } from './sddStampNode';

const switchToCartItem = fnIsSwitchToCartItems();
/**
 * Get the current mini cart data. This currently powers the header cart icon.
 * @returns An axios promise resolving to the response.
 */
export const getMiniCart = () => {
  const url = '/api/cart/000000/summary';
  return ApiInterface.get(url);
};

export const getRestoredCart = () => {
  const URL = '/api/cart/restore';
  return ApiInterface.get(URL);
};

/**
 * Updating shipping mode for user's cart
 * @param {object} data - needs documentation
 * @returns An axios promise resolving to the response.
 */
export const postUpdateShippingMode = data => {
  let requestUrl = '/api/cart/PUT/updateshippingmode';
  if (switchToCartItem) {
    requestUrl = '/api/cartitem/PUT/updateshippingmode';
  }
  return ApiInterface.post(requestUrl, data);
};

/**
 * Post checkout initialization with the specified order.
 * @param {string} orderId
 * @returns An axios promise resolving to the response.
 */
export const postInitiateCheckout = orderId => {
  const URL = `/api/cart/PUT/${orderId || '00000'}/initiate`;
  return ApiInterface.post(URL, { orderId });
};

export const postNearByStore = data => {
  const URL = '/api/cart/nearByStore';
  return ApiInterface.post(URL, data);
};
/** TO DO - Post cleanup corresponding files can refer addItemBackToCart from “src/api/cart/addItemBackToCart.js“ after removing axios from main component */
export const addToCartItems = switchToCartItem ? '/api/cartitem/sku' : '/api/cart/sku';

export { updateQty, addItemBackToCart, postApplePayAddToCart, postPayPalAddToCart, postInitiateSddStampNode, postUpdateSddStampNode };
